import { useEffect, useState } from 'react';
import { api } from '../requests/api';

const SDK_PATH = '/sdk/phone.js';

const sdk = () => window.SendbatPhone || null;

let available = false;
let startId = 0;
const availabilityListeners = new Set();

function setAvailable(value) {
    available = value;
    availabilityListeners.forEach((listener) => listener(value));
}

function loadSdk(baseUrl) {
    if (sdk()) return Promise.resolve();
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = baseUrl + SDK_PATH;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Could not load ${script.src}`));
        document.head.appendChild(script);
    });
}

/** Signed-in sessions only: the token logs into Kore as the account holding every Summit line. */
export function startPhone() {
    const id = ++startId;
    return api.get('/phone')
        .then(({ data }) => loadSdk(data.base_url).then(() => {
            // Signed out while the settings were on their way.
            if (id !== startId) return;
            sdk().init({ apiBaseUrl: data.base_url, token: data.token, showPhoneIcon: true });
            setAvailable(true);
        }))
        .catch((error) => console.error('Kore phone not started:', error.message));
}

export function stopPhone() {
    startId++;
    if (available) sdk().destroy();
    setAvailable(false);
}

export function usePhoneAvailable() {
    const [isAvailable, setIsAvailable] = useState(available);
    useEffect(() => {
        availabilityListeners.add(setIsAvailable);
        setIsAvailable(available);
        return () => availabilityListeners.delete(setIsAvailable);
    }, []);
    return isAvailable;
}

export function phoneCall(number, name) {
    if (!number || !available) return;
    sdk().call(String(number), name || '');
}

export function phoneOpen() {
    if (!available) return;
    sdk().open();
}

/**
 * Subscribe to a phone SDK event.
 * Returns an unsubscribe function.
 */
export function phoneOn(event, handler) {
    if (!sdk()) return () => {};
    sdk().on(event, handler);
    return () => sdk() && sdk().off(event, handler);
}
